<template>
    <client-chat-wrap v-slot="{ attrs, on }">
        <v-btn fixed right bottom fab elevation="16" color="primary" class="mx-8 my-8 rounded-xl" v-bind="attrs" v-on="on">
            <v-icon large>mdi-chat-question</v-icon>
        </v-btn>
    </client-chat-wrap>
</template>

<script>
import ClientChatWrap from "./chat/client-chat-wrap.vue";

export default {
    components: {
        ClientChatWrap,
    },
};
</script>

<style>
</style>